import { IAddon, IAddOnAxes } from "@stores/addons/types";
import { indexAddOnsByType } from "@stores/addons/utils";
import { isAnnualPlan } from "@stores/plans/utils";
import { IPurchase } from "@stores/purchases/types";
import { AddonSubscribedProductType } from "@stores/subscriptions/types";
import {
  getAddonSubscribedProducts,
  isSubscriptionInTrial,
} from "@stores/subscriptions/utils";
import { getRemoveAddonPayload, getUpsertAddOnsFor } from "./payloads";
import { AddOnConfigType, IPurchaseContext, IUpsertContext } from "./types";

export function buildPurchaseContext(
  purchase: IPurchase,
  config: AddOnConfigType,
  addOns: IAddon[],
): IPurchaseContext {
  const subscribedByType: IPurchaseContext["subscribedByType"] = {};
  getAddonSubscribedProducts(purchase.subscription.subscribed_products).forEach(
    (subscribed: AddonSubscribedProductType) => {
      subscribedByType[subscribed.product_type] = subscribed;
    },
  );

  const isCloudHosted = !!purchase.hosted_instance;
  const isYearly = isAnnualPlan(purchase.product.plan);

  const ctx: IPurchaseContext = {
    purchase,
    config,
    isCloudHosted,
    isYearly,
    isTrial: isSubscriptionInTrial(purchase.subscription),
    canChangeSubscription:
      purchase.subscription.status !== "cancellation-pending",
    subscribedByType,
    addOnsByType: indexAddOnsByType(addOns, { isCloudHosted, isYearly }),
    getUpsertAddOnsFor: (productType, units) =>
      getUpsertAddOnsFor(ctx, productType, units),
    getRemoveAddOnsFor: (productType) =>
      getRemoveAddonPayload(ctx, productType),
  };

  return ctx;
}

/** a purchase that does not exist yet: nothing subscribed, only flags and the catalogue */
export function buildCheckoutContext(
  config: AddOnConfigType,
  addOns: IAddon[],
  axes: IAddOnAxes,
): IUpsertContext {
  const ctx: IUpsertContext = {
    config,
    subscribedByType: {},
    addOnsByType: indexAddOnsByType(addOns, axes),
    getUpsertAddOnsFor: (productType, units) =>
      getUpsertAddOnsFor(ctx, productType, units),
  };

  return ctx;
}
